var COMMON_PREFIX = "arknights/game/assets/";
export var LOCALE_MAP = {
    cn: {
        host: "https://web.hycdn.cn",
        prefix: COMMON_PREFIX,
    },
    tw: {
        host: "https://ak-tw.hg-cdn.com",
        prefix: COMMON_PREFIX,
    },
    jp: {
        host: "https://ark-jp-static-online.yo-star.com",
        prefix: COMMON_PREFIX,
    },
    en: {
        host: "https://ark-us-static-online.yo-star.com",
        prefix: COMMON_PREFIX,
    },
    kr: {
        host: "https://ark-kr-static-online-1300509597.yo-star.com",
        prefix: COMMON_PREFIX,
    },
};
